import { z } from "zod";

export const exchangeRate = z
  .union([z.string(), z.number()])
  .refine((input) => Number(input) > 0, {
    message: "Η ισοτιμία πρέπει να είναι μεγαλύτερη από το μηδέν",
  })
  .refine(
    (input) => {
      const n = Number(input);
      return Number(n.toFixed(5)) === n;
    },
    { message: "Η ισοτιμία μπορεί να έχει μέχρι 5 δεκαδικά ψηφία" }
  )
  .transform((input) => String(input));
